import { Segment } from './segment';
import { initSprig } from './init-sprig';

export { Segment, initSprig };
